import { IconifyIcon } from 'iconify-icon'

export const IconJournalIllustrations: IconifyIcon = {
	body:
		'<svg xmlns="http://www.w3.org/2000/svg" width="410" height="337" viewBox="0 0 410 337"><path fill="#fff" fill-rule="evenodd" d="M0,49.756L197.98-.007,264.237,264.34,66.255,314.1Zm13.612,8.92L190.188,14.293l47.231,188.436L60.84,247.112ZM187,290l87-22-4-19,63,21L396,87,225,28l-8,18-5-14,6-19L410,79,321,337Z"/></svg>',
	width: 410,
	height: 337,
}
export default IconJournalIllustrations
